import React, { Component } from 'react';
import { Button, Snackbar, Switch } from 'react-md';
import Tile from './Tile';
import TileCoordinator from './TileCoordinator';
import Header from './Header';
import UIfx from 'uifx';
import clickAudio from './sounds/click.mp3'

const pubSub = require('./util/pubsub');

const clickSound = new UIfx(
    clickAudio,
    {
      volume: 0.4, // number between 0.0 ~ 1.0
      throttleMs: 100
    }
  )
const BOARD_WIDTH = 600;
const BOARD_HEIGHT =  600;
const BOARD_SPACING_RATIO = 0.2;
const BOARD_TILE_RATIO = 0.01;

const EVENT_UNSUB_ALL = 'event-unsub-all';

class Room extends Component {

    constructor(props) {
        super(props);

        const tileTextSize = BOARD_TILE_RATIO * Math.min(BOARD_WIDTH, BOARD_HEIGHT);

        const specs = {
            board: {
                width: BOARD_WIDTH,
                height: BOARD_HEIGHT,
                spacing: {
                    horizontal: BOARD_WIDTH * BOARD_SPACING_RATIO,
                    vertical: BOARD_HEIGHT * BOARD_SPACING_RATIO
                }
            },
            tile: {
                width: tileTextSize * Tile.CSS_WIDTH_EM,
                height: tileTextSize * Tile.CSS_HEIGHT_EM
            }
        };

        const boardStyle = {
            width: specs.board.width,
            height: specs.board.height
        };

        this.coord = new TileCoordinator(specs);

        // Figure teammate and side players
        this.indexRight = this.getShiftedSeatIndex(props.seat, 1);
        this.indexTeammate = this.getShiftedSeatIndex(props.seat, 2);
        this.indexLeft = this.getShiftedSeatIndex(props.seat, 3);
        this.boardRotation = '';
        this.state = {
            roomName: '',
            visible: false,
            autoplay: false,
            scoreDetails:false,
            boardStyle: boardStyle,
            tileTextSize: tileTextSize,
            placeholders: [],
            hand: [],
            hands: {},
            snackbar: {
                snacks: []
            },
            starter : 0,
            seat0: {},
            seat1: {},
            seat2: {},
            seat3: {},
            scores: {
                current:{
                    a: {
                        rounds: [],
                        total: 0
                    },
                    b: {
                        rounds: [],
                        total: 0
                    }
                },
                previous: {
                    a: 0,
                    b: 0
                },
                series: {
                    a: 0,
                    b: 0
                }
            },
            isBusy: false
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.onTileClick = this.onTileClick.bind(this);
        this.onEndTileClick = this.onEndTileClick.bind(this);
        this.onEndTileCancel = this.onEndTileCancel.bind(this);
        this.onPass = this.onPass.bind(this);
        this.onSnack = this.onSnack.bind(this);
        this.onSnackDismiss = this.onSnackDismiss.bind(this);
        this.onAutoplayChange = this.onAutoplayChange.bind(this);
        this.isTurnOfCurrentPlayer = this.isTurnOfCurrentPlayer.bind(this);
        this.attemptToAutoplay = this.attemptToAutoplay.bind(this);

        const dis = this;

        pubSub.sub(EVENT_UNSUB_ALL, pubSub.sub(pubSub.EVENT_REQUEST_START, () => {
            dis.setState({ isBusy: true });
        }));

        pubSub.sub(EVENT_UNSUB_ALL, pubSub.sub(pubSub.EVENT_REQUEST_END, () => {
            dis.setState({ isBusy: false });
        }));
    }

    /**
     * 0 + 2 -> 2
     * 1 + 3 -> 4 -> 0
     * 3 + 2 -> 5 -> 1
     * 2 + 2 -> 4 -> 0
     * 3 + 1 -> 4 -> 0
     * 3 + 3 -> 6 -> 2
     */
    getShiftedSeatIndex(seatIndex, shift) {
        let sum = seatIndex + shift;
        let delta = sum - 4;
        return sum <= 3 ? sum : delta;
    }

    isTurnOfCurrentPlayer() {
        return this.props.seat === this.state.turnOf;
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        pubSub.sub(EVENT_UNSUB_ALL, this.props.service.fs.doc(`rooms/${this.props.room}/private/${this.props.seat}`).onSnapshot(doc => {
            
            if (doc.exists && doc.data().hand) {
                
                this.setState({
                    hand: doc.data().hand
                });   
            }
        }));

        pubSub.sub(EVENT_UNSUB_ALL, this.props.service.fs.doc(`rooms/${this.props.room}`).onSnapshot(doc => {
            
            if (doc.exists) {

                let room = doc.data();
                let board = room.board;
                let left;
                let right;
                let starter = room.starter;

                let scoresObj = room.scores ? room.scores : undefined;

                // Update layout of all played tiles
                let placeholders = [];
                
                if (board && board.tiles) {

                    let result = this.coord.placeTiles(board.tiles);
                    placeholders = result.placeholders;
                    left = result.left;
                    right = result.right;
                }

                // Default new state with new layout of tiles
                let newState = {
                    roomName: room.name,
                    placeholders: placeholders,
                    hands: {},
                    turnOf: room.turnOf,
                    left: left,
                    right: right,
                    starter: starter,
                    seat0: room.seat0,
                    seat1: room.seat1,
                    seat2: room.seat2,
                    seat3: room.seat3,
                    scores: scoresObj
                };

                if (this.state.turnOf !== newState.turnOf) {
                    clickSound.play();
                }

                // Check every seat to update the amount of tiles and 
                //  update the new state object before calling setState()
                for (let i = 0; i < 4; i++) {

                    const key = `seat${i}`;

                    newState.hands[key] = 0;

                    if (room[key] && room[key].handCount) {
                        newState.hands[key] = room[key].handCount;
                    }
                }

                // Define rotation based on starter vs this seat. Also,
                //  check the new state object has the state hasn't 
                //  been updated
                if (newState.starter !== undefined) {
                    
                    
                    let indexDelta = newState.starter - this.props.seat;
                    var degrees = indexDelta * -90;

                    // Keep degrees positive to match css class [0, 90, 180, 270]
                    if (degrees < 0) {
                        degrees += 360
                    }

                    this.boardRotation = `rotation${degrees}`;
                }

                this.setState(newState);
                this.attemptToAutoplay();
            }
        }));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
        pubSub.pub(EVENT_UNSUB_ALL);
    }

    attemptToAutoplay() {

        if (this.state.autoplay && this.isTurnOfCurrentPlayer()) {
            setTimeout(() => {
                if (this.state.hand && this.state.hand.length > 0) {

                    // Starting
                    if (this.state.left === undefined && this.state.right === undefined) {

                        // Check for 6|6 first...
                        let hasSixSix = false;

                        for (let i = 0; i < this.state.hand.length; i++) {

                            let tile = this.state.hand[i];

                            if (tile.a === 6 && tile.b === 6) {
                                hasSixSix = true;
                                break;
                            }
                        }

                        if (hasSixSix) {

                            this.onTileClick(6, 6);
                        } else {

                            let firstTile = this.state.hand[0];
                            this.onTileClick(firstTile.a, firstTile.b);
                        }

                        return;
                    }

                    // Mid-game
                    for (let i = 0; i < this.state.hand.length; i++) {

                        let tile = this.state.hand[i];

                        if (tile.a === this.state.left.val || tile.b === this.state.left.val
                            || tile.a === this.state.right.val || tile.b === this.state.right.val) {

                            this.onTileClick(tile.a, tile.b, true);
                            return;
                        }
                    }

                    // Passing...
                    this.onPass();
                }
            }, 5000) //5s
        }
    }

    isStuck(){

        if (this.isTurnOfCurrentPlayer()) {

            if (this.state.hand && this.state.hand.length > 0) {

                // Starting
                if (this.state.left === undefined && this.state.right === undefined) {

                    // Check for 6|6 first...
                    let hasSixSix = false;

                    for (let i = 0; i < this.state.hand.length; i++) {

                        let tile = this.state.hand[i];

                        if (tile.a === 6 && tile.b === 6) {
                            hasSixSix = true;
                            break;
                        }
                    }

                    if (hasSixSix) {
                        
                        return false
                    } else {

                        return false
                    }

                    
                }

                // Mid-game
                for (let i = 0; i < this.state.hand.length; i++) {

                    let tile = this.state.hand[i];

                    if (tile.a === this.state.left.val || tile.b === this.state.left.val
                        || tile.a === this.state.right.val || tile.b === this.state.right.val) {

                        
                        return false;
                    }
                }

                // Passing...
                return true;
            }
        }else{
            return false;
        }

    }

    updateWindowDimensions() {

        this.setState({
            window: {
                w: window.innerWidth, 
                h: window.innerHeight
            }
        });
    }

    onEndTileClick(end) {

        if (this.state.isPickingEndWith) {

            this.onEndTileCancel();
            let a = this.state.isPickingEndWith.a;
            let b = this.state.isPickingEndWith.b;
            console.debug(`Should play [${a}|${b}] in end ${end}`);
            this.props.service.playTile(a, b, this.props.room, this.props.seat, end);
        }
    }

    onEndTileCancel() {

        this.setState({ isPickingEndWith: undefined });
    }   

    onTileClick(a, b, autoplay = false) {
        if (!this.state.left || !this.state.right) {
            this.props.service.playTile(a, b, this.props.room, this.props.seat, 1);
            return;
        }

        let canPlayLeft = a === this.state.left.val || b === this.state.left.val;
        let canPlayRight = a === this.state.right.val || b === this.state.right.val;
        let canPlayBoth = canPlayLeft && canPlayRight;

        // If more than one tile has been played, then there are two real ends to check
        if (canPlayBoth && this.state.placeholders.length > 1) {

            let stateUpdateFunc = autoplay ? function() { this.onEndTileClick(-1); } : null;

            // Have end user pick an end
            this.setState({ isPickingEndWith: { a:a, b:b }}, stateUpdateFunc);
            this.onSnack(`Pick end to play [${a}|${b}]...`);
        } else {

            this.onEndTileCancel();

            // Define an end depending on which can be played 
            // (in this else block, only one of the two)
            let end;

            if (canPlayLeft) {
                end = -1;
            } else if (canPlayRight) {
                end = 1;
            }

            // If there's an end, play the tile there
            if (end) {

                console.debug(`Should play [${a}|${b}] in end ${end}`);
                this.props.service.playTile(a, b, this.props.room, this.props.seat, end);
            }
        }
    }

    onPass() {

        this.props.service.pass(this.props.room, this.props.seat);
    }

    onSnack(text, action, onAction, autohide) {

        const newSnack = {
            text,
            action: {
                children: action,
                onClick: onAction
            }
        };
        const snacks = this.state.snackbar.snacks.slice();
        snacks.push(newSnack);
        this.setState({
            snackbar: {
                snacks: snacks,
                authohide: autohide
            }
        });
    }

    onSnackDismiss() {
        const [, ...remainingSnacks] = this.state.snackbar.snacks;
        this.setState({ snackbar: { snacks: remainingSnacks } });
    }

    onAutoplayChange(isChecked, event) {
        
        let stateUpdateFunc = isChecked ? function() { this.attemptToAutoplay() } : null;

        this.setState({ autoplay: isChecked}, stateUpdateFunc);
    }

    leaveRoomBtn= ()=>{
        return(
            <Button raised secondary onClick={this.props.service.leaveRoom}>Leave room</Button>
        );
    }
    passButton = ()=>{
        if(this.isStuck())
            return (<Button raised secondary onClick={this.onPass}>Pass</Button>);
    }

    toggleScoreDetails = ()=>{
        this.setState({
            scoreDetails: !this.state.scoreDetails
        });
    }
    
    render() {

        const tilePositionOffset = {
            x: this.coord.specs.tile.width / 2,
            y: (this.coord.specs.tile.height / 2) //50px top offset to avoid blocking own tiles
        };

        const otherHandStyle = {
            width: `${Tile.CSS_WIDTH_EM}em`,
            //'height': `${Tile.CSS_HEIGHT_EM}em`,
            height: `${Tile.CSS_HEIGHT_EM * 0.2}em`,
            fontSize: this.state.tileTextSize,
        };

        const scoreDetail_style = {
            maxHeight: (this.state.scores.current.a.rounds.length * 25) + "px"
        }

        const playerTurnMessage = this.isTurnOfCurrentPlayer() ? "YOUR TURN" : "";
        let pickSideEndClass = this.state.isPickingEndWith ? 'blinkOn' : '' ;

        let teammateName = this.state[`seat${this.indexTeammate}`]
            ? this.state[`seat${this.indexTeammate}`].displayName : `Seat ${this.indexTeammate}`;
        let leftName = this.state[`seat${this.indexLeft}`]
            ? this.state[`seat${this.indexLeft}`].displayName : `Seat ${this.indexLeft}`;
        let rightName = this.state[`seat${this.indexRight}`]
            ? this.state[`seat${this.indexRight}`].displayName : `Seat ${this.indexRight}`;

        const score_a = this.state.scores ? this.state.scores.current.a.total : 0;
        const series_a = this.state.scores ? this.state.scores.series.a : 0;
        const score_b = this.state.scores ? this.state.scores.current.b.total : 0;
        const series_b = this.state.scores ? this.state.scores.series.b : 0;
        let name_a = "Team 1";
        let name_b = "Team 2";

        try {
            name_a = `${this.state.seat0.displayName} & ${this.state.seat2.displayName}`;
            name_b = this.state.seat1.displayName + " & " + this.state.seat3.displayName;
        } catch(empty) {}

        return (
            <div>
                <Header
                    title={`D6 @ ${this.state.roomName}`}
                    action={this.leaveRoomBtn()}
                    isBusy={this.state.isBusy} />
                <div className="main-content">
                    <div className="subHeaderSection">
                        <Switch id='switch-autoplay' name='autoplay' label='Autoplay' onChange={this.onAutoplayChange} />
                        <div className="scoreBoxContainer">
                            <div className="scoreBox">
                                <div className="series_score">({series_a} - {series_b})</div>
                                <div className="round_score_container" style={(this.state.scoreDetails) ? scoreDetail_style : null}   >
                                    <div className="team_rounds">
                                        {
                                            this.state.scores.current.a.rounds.map((round, index) => {
                                                let r = this.state.scores.current.a.rounds;
                                                let prev = (index) ? r.slice(0, index ).reduce((a,b)=>{return a+b}) : 0;
                                                return <div> {prev} - {round}</div>;
                                            })
                                        }
                                    </div>
                                    <div className="team_rounds">
                                        {
                                            
                                            this.state.scores.current.b.rounds.map((round, index) => {
                                                let r = this.state.scores.current.b.rounds;
                                                let prev = (index) ? r.slice(0, index ).reduce((a,b)=>{return a+b}) : 0;
                                            return <div key={`score-${index}`}>{prev} - {round}</div>;
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="team_scores">
                                    <div className="team">
                                        <div className="team_name">{name_a}</div>
                                        <div className="score"> {score_a}</div>
                                    </div>
                                    <div className="team">
                                        <div className="team_name">{name_b}</div>
                                        <div className="score">{score_b}</div>
                                    </div>
                                </div>

                                <div className="score_details_btn_container" onClick={this.toggleScoreDetails}>
                                    <div style={(this.state.scoreDetails) ? { transform: 'rotate(180deg)', transformOrigin: '50% 50%' } : {}}> &#8964; </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <span style={{ display: 'none' }}>{this.props.seat} @ {this.props.room}</span>

                    <div className="gameArea">
                        <div className="teammate">
                            <div className={this.state.turnOf === this.indexTeammate ? "active-player" : null}>{teammateName}</div>

                            {
                                Array.apply(null, Array(this.state.hands[`seat${this.indexTeammate}`])).map((value, index) => {
                                    return <div className="otherHand otherHand_teamate" key={index} style={otherHandStyle}></div>
                                })
                            }
                        </div>
                        <div className="midSection">
                            <div className="other-team">
                                <div className={this.state.turnOf === this.indexLeft ? "active-player" : null}>{leftName}</div>
                                {
                                    Array.apply(null, Array(this.state.hands[`seat${this.indexLeft}`])).map((value, index) => {
                                        return <div className="otherHand" key={index} style={otherHandStyle}></div>
                                    })
                                }
                            </div>
                            <div className="gameBoard" >
                                <div className={`gameTiles ${pickSideEndClass} ${this.boardRotation}`} style={this.state.boardStyle}>
                                    {
                                        this.state.placeholders.map((value, index) => {

                                            let isLeft = this.state.left
                                                && this.state.left.holder.tile === value.tile;
                                            let isRight = this.state.right
                                                && this.state.right.holder.tile === value.tile;

                                            // Define clicker for both ends
                                            let clickHandler;

                                            if (isLeft) {

                                                clickHandler = () => { this.onEndTileClick(-1); };
                                            } else if (isRight) {

                                                clickHandler = () => { this.onEndTileClick(1); };
                                            }

                                            return <Tile key={index} index={index}
                                                a={value.tile.a} b={value.tile.b}
                                                x={value.x - tilePositionOffset.x} y={value.y - tilePositionOffset.y}
                                                d={value.d}
                                                tileTextSize={this.state.tileTextSize}
                                                clickHandler={clickHandler}
                                            />
                                        })
                                    }
                                </div>
                            </div>
                            <div className="other-team">
                                <div className={this.state.turnOf === this.indexRight ? "active-player" : null}>{rightName}</div>
                                {
                                    Array.apply(null, Array(this.state.hands[`seat${this.indexRight}`])).map((value, index) => {
                                        return <div className="otherHand" key={index} style={otherHandStyle}></div>
                                    })
                                }
                            </div>
                        </div>
                        <div>{playerTurnMessage}</div>
                        <div className="userHand">
                            {
                                this.state.hand.map((value, index) => {
                                    return <Tile key={index} index={index}
                                        a={value.a} b={value.b}
                                        x={value.x - tilePositionOffset.x} y={value.y - tilePositionOffset.y}
                                        d={value.d}
                                        tileTextSize={this.state.tileTextSize}
                                        clickHandler={() => { this.onTileClick(value.a, value.b); }} />
                                })
                            }
                            {this.passButton()}
                        </div>
                    </div>
                    <Snackbar
                        toasts={this.state.snackbar.snacks}
                        autohide={this.state.snackbar.autohide}
                        onDismiss={this.onSnackDismiss} />
                </div>

            </div>
        );
    }
}

export default Room;


// WEBPACK FOOTER //
// ./src/Room.jsx